// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerNotification {
  align-items: center;
  position: absolute;
  top: 20px;
  right: 15px;
  min-height: 35px;
  display: flex;
  font-size: 12px;
  z-index: 1000;
  padding: 5px 10px;
  margin-right: 20px;
}

.justifyText {
  text-align: start;
}
.iconErro {
  width: 18px;
  height: 18px;
  margin-left: 3px;
}

.CloseMensageError {
  width: 15px;
  height: 15px;
  margin-left: 15px;
  margin-right: 15px;
  cursor: pointer;
}

.circleAlertError {
  width: 7px;
  height: 7px;
  border-radius: 100px;
  background-color: #ff2124;
  position: relative;
  bottom: 7px;
  right: 9px;
}
.labelErro {
  margin-left: 6px;
}

.iconClose{
  width: 15px;
  height: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-tax/Notification/notification.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".containerNotification {\n  align-items: center;\n  position: absolute;\n  top: 20px;\n  right: 15px;\n  min-height: 35px;\n  display: flex;\n  font-size: 12px;\n  z-index: 1000;\n  padding: 5px 10px;\n  margin-right: 20px;\n}\n\n.justifyText {\n  text-align: start;\n}\n.iconErro {\n  width: 18px;\n  height: 18px;\n  margin-left: 3px;\n}\n\n.CloseMensageError {\n  width: 15px;\n  height: 15px;\n  margin-left: 15px;\n  margin-right: 15px;\n  cursor: pointer;\n}\n\n.circleAlertError {\n  width: 7px;\n  height: 7px;\n  border-radius: 100px;\n  background-color: #ff2124;\n  position: relative;\n  bottom: 7px;\n  right: 9px;\n}\n.labelErro {\n  margin-left: 6px;\n}\n\n.iconClose{\n  width: 15px;\n  height: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
